export default __webpack_public_path__ + "static/media/boxtype5.bfd23c75.JPG";